import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import { Input, SubTitle } from "../../Components";
import TextEditor from "../../Components/TextEditor";
import { useGetStaticPageQuery, useSavePageMutation } from "../../store/apis/settingsApi";
import { errorMsg, successMsg } from "../../constants/msgs";
import ThemeSpinner from "../../Components/general/ThemeSpinner";
import { PlaceholderButton, PlaceholderTextEditor } from "../../Components/Placeholders";
// import { useAddOrUpdateStaticPagesMutation } from "../../Data/services/settingApi";
// import Toast, { SuccessToast } from "../../Hooks/useToast";
// import styles from "./styles/StaticPage.module.scss";

export default function DigitDreamRules() {
  const [value, setValue] = useState(
    "<h1>Privacy Policy</h1><h2>What is Lorem Ipsum?</h2><p><br></p><p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p > <p><br></p>"
  );

  const [link, setLink] = useState("");
  const [slug, setSlug] = useState("");

  const { data, isSuccess, isFetching: dataFetching, refetch } = useGetStaticPageQuery(
    { type: "digit_dream-rules" },
    { refetchOnMountOrArgChange: true }
  );

  // var policyData = useSelector((state) => state.settings.pages[1]);

  // useEffect(() => {
  //   setValue(policyData.content);
  //   setLink(policyData.url);
  //   setSlug(policyData.slug);
  // }, [policyData]);

  useEffect(() => {
    console.log(data);
    if (isSuccess) {
      setValue(data?.data?.text);
      // setLink(data?.url);
      setSlug(data?.data?.type);
    }
  }, [data, isSuccess]);

  const handleLinkChange = (e) => {
    // console.log(e.target.value);
    setLink(e.target.value);
  };

  const handleValueChange = (newText) => {
    setValue(newText);
    // console.log("Updated text:", newText);
  };

  const [updatePolicy, { isLoading }] = useSavePageMutation();

  const handleSaveText = async () => {
    // console.log(value);
    // const data = {
    //   title: "Privacy Policy",
    //   content: value,
    //   url: link,
    // };
    // console.log(data);

    const data = {
      // title: "Terms & Conditions",
      text: value,
      // url: link,
    };
    console.log(data);
    console.log(slug);

    try {
      const response = await updatePolicy({ data: data, type: slug });

      if (response.data.code === 200) {
        successMsg(response?.data?.message);
        refetch();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorMsg(error?.response?.data?.message, "error");
      } else {
        errorMsg("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className={"StaticPage"}>
      <Row style={{ height: "auto" }}>
        <Col sm={10}>
          <SubTitle text="Digit Dream Rules" classes="mb-4 text-white" />
          {/* <Input
            name="link"
            type="text"
            value={link}
            onChange={handleLinkChange}
          //  onChange={()=>{}}
          /> */}
        </Col>
        <Col sm={2}>
          {
            dataFetching ?
              <PlaceholderButton />
              :
              <Button
                // type="submit"
                className={`btn-solid btn-red w-100 `}
                // text={false ? <BeatLoader size={10} /> : "Save"}
                onClick={handleSaveText}
                // onClick={()=>{}}
                disabled={isLoading}
              > {isLoading ? <ThemeSpinner /> : "Save"} </Button>}
        </Col>
      </Row>

      {
        dataFetching ?
          <PlaceholderTextEditor />
          :
          <TextEditor text={value} onChange={setValue} />
      }
    </div>
  );
}
